import CloseButton from '@Components/Common/CloseButton';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { Modal, Portal } from 'react-native-paper';

type Props = {
  visible: boolean;
  onDismiss?: () => void;
  onClose?: () => void;
  children?: ReactNode;
};

export const ModalWrapper = observer(function ModalWrapper({
  visible,
  onDismiss,
  onClose,
  children,
}: Props) {
  return (
    <Portal>
      <Modal
        theme={{ colors: { backdrop: 'transparent' } }}
        visible={visible}
        onDismiss={onDismiss}
        contentContainerStyle={styles.container}
        style={styles.wrapper}
      >
        <View style={styles.closeButton}>
          <CloseButton
            iconColor={OwnableTheme.colors.white}
            bgColor={OwnableTheme.colors.black}
            size='xsmall'
            onPress={onClose}
          />
        </View>
        {children}
      </Modal>
    </Portal>
  );
});

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    backgroundColor: OwnableTheme.colors.white,
    paddingHorizontal: 30,
    paddingVertical: 50,
    borderRadius: 15,
    shadowColor: OwnableTheme.colors.black,
    shadowOpacity: 0.15,
    shadowRadius: 30,
  },
  closeButton: { position: 'absolute', top: 0, right: -40 },
});
